// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['comissao_avaliacao']


const DEFAULT_URL = '/enriquecer-dados';

const enriquecerDadosBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Enriquecer Dados',
    to: 'enriquecer-dados'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'enriquecer-dados',
    component: () => import('@/views/EnriquecerDados/EnriquecerDadosForm.vue'),
    meta: {
      roles: ROLES,
      title: 'Enriquecer Dados',
      breadcrumb: [
          ...enriquecerDadosBreadCrumb
      ]
    }
  }
]